/**
 * Lotus outline for the "Mir" chip (APP1). Lucide has no lotus; this follows its 24 px grid,
 * 2 px round stroke and currentColor, so it sits beside the Lucide icons unchanged.
 */
import type { SVGProps } from 'react';

export function LotusIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M12 4c-2.5 3-3 8.5 0 13 3-4.5 2.5-10 0-13Z" />
      <path d="M11 16.5C7.5 16 5 13.5 4.5 9.5c2.6.2 4.6 1.5 5.9 3.5" />
      <path d="M13 16.5c3.5-.5 6-3 6.5-7-2.6.2-4.6 1.5-5.9 3.5" />
      <path d="M5 20c2.2.7 4.5 1 7 1s4.8-.3 7-1" />
    </svg>
  );
}
